import React, {useState} from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from './imgs/Textura Pro_Bespoke.webp'
import img2 from './imgs/Textura Pro_Unlock.webp'
import img3 from './imgs/Textura Pro_Our packages.webp'
import img4 from './imgs/Textura Pro_Match.webp'
import img5 from './imgs/UPDATED_02.webp'
import {TexturaProText} from "./text";
import {Carousel} from 'antd';
import {Text} from "../../pages/Contact/text";
import './style.scss'
import slider1 from './imgs/Slider 1.webp'
import slider2 from './imgs/Slider 2.webp'
import slider3 from './imgs/Slider 3.webp'
import slider4 from './imgs/Slider 4.webp'
import {ReactComponent as ClockIcon} from "./imgs/24-7.svg";
import img_1 from "../ProHome/images/Portal Image no line.webp";
import {ReactComponent as FrameIcon} from "./imgs/4 Frame options.svg";
import {ReactComponent as LibraryIcon} from "./imgs/Extensive Library.svg";


const PreArrow = () =>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="45" viewBox="0 0 28 45" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M26.4026 7.53936C27.9647 5.97727 27.9647 3.44461 26.4026 1.88251C24.8405 0.320413 22.3079 0.320413 20.7458 1.88251L10.5589 12.0694L0.372007 22.2563L0.563914 22.4482L0.261719 22.7504L20.6355 43.1242C22.1976 44.6863 24.7303 44.6863 26.2924 43.1242C27.8545 41.5621 27.8545 39.0294 26.2924 37.4673L11.3835 22.5585L16.2158 17.7263L26.4026 7.53936Z"
              fill="white"/>
    </svg>
const NxArrow = () => <svg xmlns="http://www.w3.org/2000/svg" width="28" height="45" viewBox="0 0 28 45" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.43329 7.53936C-0.128805 5.97727 -0.128805 3.44461 1.43329 1.88251C2.99539 0.320413 5.52805 0.320413 7.09015 1.88251L17.277 12.0694L27.4639 22.2563L27.272 22.4482L27.5742 22.7504L7.20043 43.1242C5.63834 44.6863 3.10568 44.6863 1.54358 43.1242C-0.0185165 41.5621 -0.0185165 39.0294 1.54358 37.4673L16.4524 22.5585L11.6202 17.7263L1.43329 7.53936Z"
          fill="white"/>
</svg>
// Updated arrow components with additional styling
const StyledPreArrow = ({onClick}) => (
    <div className="carousel-arrow carousel-prev-arrow" onClick={onClick}>
        <PreArrow></PreArrow>
    </div>
);

const StyledNxArrow = ({onClick}) => (
    <div className="carousel-arrow carousel-next-arrow" onClick={onClick}>
        <NxArrow></NxArrow>
    </div>
);
const FiveStars = () => <svg xmlns="http://www.w3.org/2000/svg" width="148" height="20" viewBox="0 0 148 22"
                             fill="none">
    <path
        d="M10.7615 4.61688L12.1538 7.96427L12.5056 8.81021L13.4189 8.88342L17.0327 9.17314L14.2794 11.5317L13.5836 12.1277L13.7961 13.0189L14.6373 16.5453L11.5434 14.6556L10.7615 14.178L9.97966 14.6556L6.88575 16.5453L7.72694 13.0189L7.93952 12.1277L7.24371 11.5317L4.49039 9.17314L8.10417 8.88342L9.01744 8.81021L9.36928 7.96427L10.7615 4.61688Z"
        fill="black" stroke="#030303" stroke-width="3"/>
    <path
        d="M42.2606 4.61688L43.6528 7.96427L44.0047 8.81021L44.9179 8.88342L48.5317 9.17314L45.7784 11.5317L45.0826 12.1277L45.2952 13.0189L46.1364 16.5453L43.0424 14.6556L42.2606 14.178L41.4787 14.6556L38.3848 16.5453L39.226 13.0189L39.4385 12.1277L38.7427 11.5317L35.9894 9.17314L39.6032 8.88342L40.5165 8.81021L40.8683 7.96427L42.2606 4.61688Z"
        fill="black" stroke="#030303" stroke-width="3"/>
    <path
        d="M73.7576 4.61688L75.1499 7.96427L75.5017 8.81021L76.415 8.88342L80.0288 9.17314L77.2755 11.5317L76.5797 12.1277L76.7922 13.0189L77.6334 16.5453L74.5395 14.6556L73.7576 14.178L72.9758 14.6556L69.8818 16.5453L70.723 13.0189L70.9356 12.1277L70.2398 11.5317L67.4865 9.17314L71.1003 8.88342L72.0135 8.81021L72.3654 7.96427L73.7576 4.61688Z"
        fill="black" stroke="#030303" stroke-width="3"/>
    <path
        d="M105.263 4.61688L106.656 7.96427L107.008 8.81021L107.921 8.88342L111.535 9.17314L108.781 11.5317L108.086 12.1277L108.298 13.0189L109.139 16.5453L106.045 14.6556L105.263 14.178L104.482 14.6556L101.388 16.5453L102.229 13.0189L102.441 12.1277L101.746 11.5317L98.9923 9.17314L102.606 8.88342L103.519 8.81021L103.871 7.96427L105.263 4.61688Z"
        fill="black" stroke="#030303" stroke-width="3"/>
    <path
        d="M136.763 4.61688L138.155 7.96427L138.507 8.81021L139.42 8.88342L143.034 9.17314L140.28 11.5317L139.585 12.1277L139.797 13.0189L140.638 16.5453L137.544 14.6556L136.763 14.178L135.981 14.6556L132.887 16.5453L133.728 13.0189L133.94 12.1277L133.245 11.5317L130.491 9.17314L134.105 8.88342L135.018 8.81021L135.37 7.96427L136.763 4.61688Z"
        fill="black" stroke="#030303" stroke-width="3"/>
</svg>

const TexturaPro = (props) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    return (
        <Layout>
            <Content style={{backgroundColor: '#F4F4F4'}}>
                <Row justify={"center"} style={{marginTop: '8rem'}} gutter={32}>
                    <Col lg={15}>
                        <Carousel arrows={true}
                                  prevArrow={<StyledPreArrow onClick={() => setCurrentSlide(currentSlide - 1)}/>}
                                  nextArrow={<StyledNxArrow onClick={() => setCurrentSlide(currentSlide + 1)}/>}
                                  afterChange={(current) => setCurrentSlide(current)}
                                  initialSlide={currentSlide}
                        >
                            <div>
                                <img className={'slider-img'} src={slider1}/>
                            </div>
                            <div>
                                <img className={'slider-img'} src={slider2}/>
                            </div>
                            <div>
                                <img className={'slider-img'} src={slider3}/>
                            </div>
                            <div>
                                <img className={'slider-img'} src={slider4}/>
                            </div>
                        </Carousel>
                    </Col>
                    <Col lg={5}>
                        <p className={'textura-pro-top-title'}>
                            {TexturaProText['top'][0]}
                        </p>
                        <p className={'textura-pro-top-txt'}>
                            {TexturaProText['top'][1]}
                        </p>
                        <Button
                            className={'pro-buy-now-btn pro-btn-hover-to-white'}
                            onClick={_ => window.location.href = '/business/shopping'}
                        >
                            Buy now
                        </Button>
                        <p className={'pro-buy-bottom-text'}>
                            Cost for hardware £640. Subscription fees may apply
                        </p>
                        <div className={'textura-pro-contact-div'}>
                            <p className={'textura-pro-contact-div-1'}>
                                Need advice on what package is most suitable for your business? Let our team guide you through the options!
                            </p>
                            <p className={'textura-pro-contact-div-2'}>
                                Call: 03455-481311
                            </p>
                            <p className={'textura-pro-contact-div-3'}>
                                or email: info@vieunite.com
                            </p>
                        </div>
                        <div className={'textura-pro-reviews'}>
                            <FiveStars/>
                            <p className={'textura-pro-rv'}
                               onClick={_ => window.open('https://www.google.com/search?q=vieunite&rlz=1C5CHFA_enGB1000GB1000&oq=vieunite&gs_lcrp=EgZjaHJvbWUqDAgAECMYJxiABBiKBTIMCAAQIxgnGIAEGIoFMhMIARAuGIMBGK8BGMcBGLEDGIAEMgYIAhAAGAMyBggDEEUYPDIGCAQQRRg8MgYIBRBFGDwyBggGEEUYPDIGCAcQRRg80gEIMTY3MGowajeoAgCwAgA&sourceid=chrome&ie=UTF-8#lrd=0x4870977ec8050345:0x915d3cd29fa952d8,1,,,,')}>
                                Reviews
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row justify={"center"} style={{padding: '4rem 0 4rem 0'}}>
                    <Col lg={5} className={'textura-pro-icon-and-txt'}>
                        <ClockIcon/><p className={'textura-pro-small-icon-txt'}>24-7 commercial use</p>
                    </Col>
                    <Col lg={5} className={'textura-pro-icon-and-txt'}>
                        <LibraryIcon/><p className={'textura-pro-small-icon-txt'}>Extensive art library</p>
                    </Col>
                    <Col lg={5} className={'textura-pro-icon-and-txt'}>
                        <FrameIcon/><p className={'textura-pro-small-icon-txt'}>Four frames options</p>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Col lg={10}>
                        <p className={'textura-pro-title'}>
                            {TexturaProText['l1'][0]}
                        </p>
                        <p className={'textura-pro-txt'}>
                            {TexturaProText['l1'][1]}
                        </p>
                        <img style={{borderRadius: '1rem'}} src={img1}/>
                    </Col>
                    <Col lg={10}>
                        <p className={'textura-pro-title'}>
                            {TexturaProText['r1'][0]}
                        </p>
                        <p className={'textura-pro-txt'}>
                            {TexturaProText['r1'][1]}
                        </p>
                        <img style={{borderRadius: '1rem'}} src={img2}/>
                    </Col>
                </Row>
                <Row justify={"center"} style={{
                    margin: '4rem 0 4rem 0'
                }}>
                    <Col lg={10}>
                        <p className={'textura-pro-title'}>
                            {TexturaProText['l2'][0]}
                        </p>
                        <p className={'textura-pro-txt'}>
                            {TexturaProText['l2'][1]}
                        </p>
                        <img style={{borderRadius: '1rem'}} src={img3}/>
                    </Col>
                    <Col lg={10}>
                        <p className={'textura-pro-title'}>
                            {TexturaProText['r2'][0]}
                        </p>
                        <p className={'textura-pro-txt'}>
                            {TexturaProText['r2'][1]}
                        </p>
                        <img style={{borderRadius: '1rem'}} src={img4}/>
                    </Col>
                </Row>
                <Row justify={"center"} className={'j-section'} style={{marginTop: '-1rem'}}>
                    <img src={img5} style={{'width': '78.8vw', margin: '4rem auto 4rem 8vw'}} className={'j-img'}></img>
                    <div className="j-text-overlay" style={{top: '15%', left: '13%'}}>
                        <p className={'j-h1-add'}>Additional Services</p>
                        <p className={'j-txt-add-h'}>
                            At the heart of Vieunite Pro lies simplicity, streamlining, and a user-friendly
                            experience. In just minutes, you can effortlessly craft collections or playlists,
                            schedule content, and send commands with unparalleled ease. Combined with this we can
                            also offer:
                        </p>
                        <p className={'j-txt-add'}>
                            &nbsp;&#8226;&nbsp;Allocated artists for bespoke playlists
                        </p>
                        <p className={'j-txt-add'}>
                            &nbsp;&#8226;&nbsp;Installation of Textura digital canvases
                        </p>
                        <p className={'j-txt-add'}>
                            &nbsp;&#8226;&nbsp;Onsite survey
                        </p>
                        <p className={'j-txt-add'}>
                            &nbsp;&#8226;&nbsp;Hardware warranty
                        </p>
                        <p className={'j-txt-add'}>
                            &nbsp;&#8226;&nbsp;Extra Yearly warranty
                        </p>
                    </div>
                </Row>
            </Content>
        </Layout>
    )
}

export default TexturaPro;
